import { EMPTY_STRING } from '../../../../constants/common'
import { SpeechToTextError } from '../../../../constants/speechToText'
import { AI_VOICE_INPUT_ERROR } from '../../AITextGeneration.constants'

export function appendTranscript(existing, transcript) {
  const safeExisting = existing || EMPTY_STRING
  const trimmed = (transcript || EMPTY_STRING).trim()

  if (!trimmed) {
    return safeExisting
  }

  if (!safeExisting) {
    return trimmed
  }

  return /\s$/.test(safeExisting)
    ? safeExisting + trimmed
    : `${safeExisting} ${trimmed}`
}

export function mapSpeechToTextErrorToAiVoiceError(errorCode) {
  if (errorCode === SpeechToTextError.MicrophonePermissionDenied) {
    return AI_VOICE_INPUT_ERROR.NoMicrophoneAccess
  }

  if (errorCode === SpeechToTextError.QuotaError) {
    return AI_VOICE_INPUT_ERROR.OutOfTokens
  }

  return AI_VOICE_INPUT_ERROR.ServiceError
}
